import { DennemeyerDocument, DennemeyerIpRightDocuments } from '../dennemeyer/new_way/documents'
import { useSettings } from './Settings'

export function DocumentProvider({ id, children }: { id: string; children: React.ReactNode }) {
  const { implementation } = useSettings()
  if (implementation === 'dennemeyer') {
    return <DennemeyerDocument {...{ id }}>{children}</DennemeyerDocument>
  } else {
    return children
  }
}

export function IpRightDocumentsProvider({ ipRightId, children }: { ipRightId: string; children: React.ReactNode }) {
  const { implementation } = useSettings()
  if (implementation === 'dennemeyer') {
    return <DennemeyerIpRightDocuments {...{ ipRightId }}>{children}</DennemeyerIpRightDocuments>
  } else {
    return children
  }
}
